<div class="top flex flex-col py-[6px]">
  <div class="flex flex-row">

    <!-- start template-->
    <div
      class="flex flex-col justify-center"
      *ngIf="!startTemplate && icon">
      <i class="flex text-[2rem] pr-2" 
        [ngClass]=icon></i>
    </div>
    <ng-template *ngTemplateOutlet="startTemplate"></ng-template>

    <!-- main content -->
    <div class="grow w-full">
      <div class="flex flex-row min-h-[28px] pb-[2px]">
        <div class="flex flex-row grow">
        <!-- label -->
          <div
            *ngIf="!labelTemplate"
            [ngClass]="getLabelClass()">
            {{label | translate}}
          </div>
          <ng-template *ngTemplateOutlet="labelTemplate"></ng-template>

          <!-- tag -->
          <!-- for the tag we keep a containg div here, to make it easier to use
              I dont expect such varying content here. The margin is set for displaying
              tag(s) (p-tag) exactly on the same height as the label -->
          <div
            *ngIf="tagTemplate"
            class="mt-[-0.188rem] ml-2">
            <ng-template *ngTemplateOutlet="tagTemplate"></ng-template>
          </div>
        </div>
        <div
          *ngIf="mainEndTemplate">
          <ng-template *ngTemplateOutlet="mainEndTemplate"></ng-template>
        </div>
      </div>

      <!-- content  or sub label -->
      <!-- if the box is in body mode, we show here a subLabel instead the whole content -->
      <!-- content -->
      <ng-container
        *ngIf="!bodyTemplate">
        <div
          *ngIf="!contentTemplate" 
          [ngClass]="getContentClass()">
          <div #contentWrapper>
            <ng-content></ng-content>
          </div>
          <span *ngIf="!contentAvailable(contentWrapper)">
            -
          </span>
        </div>
        <ng-template *ngTemplateOutlet="contentTemplate"></ng-template>
      </ng-container>
      <!-- sub label -->
      <ng-container
        *ngIf="bodyTemplate">
        <!-- subLabel -->
        <div
          *ngIf="!subLabelTemplate"
            [ngClass]="getSubLabelClass()">
            {{subLabel}}
        </div>
        <ng-template *ngTemplateOutlet="subLabelTemplate"></ng-template>
      </ng-container>

    </div>

    <!-- end -->
    <div
      *ngIf="shouldShowButton()"
      class="flex flex-col justify-center ml-2">
      <p-menu
        #menu 
        (onShow)="onMenuShow()"
        (onHide)="onMenuHide()"
        [model]="_menuItems" 
        [popup]="true"
        [appendTo]="'body'"></p-menu>
      <nx-default-button
        [ngClass]="{
          'nx-focus': menuVisible
        }"
        (click)="menu.toggle($event)" 
        [icon]="'icon-options'">
      </nx-default-button>
    </div>
    <ng-template *ngTemplateOutlet="endTemplate"></ng-template>

  </div>
</div>
<div *ngIf="bodyTemplate" class="px-5 pt-1 pb-2 text-base">
  <ng-template *ngTemplateOutlet="bodyTemplate"></ng-template>
</div>